module.exports = __webpack_public_path__ + "5c02c5e8ffe3d3118424860151f654ea.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Game/dude.png
 ** module id = 341
 ** module chunks = 0
 **/